import styled from "@emotion/styled";
import type { FC, ReactNode } from "react";

import { ReactComponent as DownArrowSVG } from "../../assets/down-arrow.svg";
import { useLanguageContext } from "../../contexts/language/language";
import { useSwapContextState } from "../../contexts/swap";
import type { PoolOperation } from "../../utils/pools";
import { formatStringWithPlaceholders } from "../../utils/utils";
import { AmountInput } from "../AmountInput/AmountInput";
import { TradeButton } from "../Trade";
import type { StakeAction } from "./StakingTabs";

export enum STAKE_ENUM {
  STAKE = "stake",
  UNSTAKE = "unstake",
}
type StakingProps = {
  poolStakingOperation: PoolOperation.StepStaking | PoolOperation.MarinadeStake | PoolOperation.MarinadeUnstake;
  stakeAction: StakeAction;
  buttonMessage: string | ReactNode;
  stakeActionDisabled?: boolean;
  onStakeAction: (stakingAction: StakeAction) => void;
  className?: string;
  iconSize?: number;
};

export const Staking: FC<StakingProps> = ({
  poolStakingOperation,
  stakeAction,
  onStakeAction,
  buttonMessage,
  stakeActionDisabled = false,
  className,
  iconSize = 28,
}) => {
  const { A, B, setLastTypedAccount, setPoolOperation, recalculateDependent } = useSwapContextState();

  const {
    currentLanguageData: {
      common: { amountInputLabels },
    },
  } = useLanguageContext();

  return (
    <>
      <StakingContainer className={className}>
        <AmountInput
          headerText={formatStringWithPlaceholders(amountInputLabels.youWill, amountInputLabels.stake)}
          amount={A.amount}
          mint={A.mintAddress}
          onAmountChange={(event, rawValue) => {
            setPoolOperation(poolStakingOperation);
            const amount = rawValue;
            if (A.amount !== amount) {
              setLastTypedAccount(A.mintAddress);
            } else {
              recalculateDependent();
            }

            A.setAmount(amount);
          }}
          showHalfButton={true}
        />
        <IconWrapper>
          <DownArrowSVG height={iconSize} width={iconSize} />
        </IconWrapper>
        <AmountInput
          headerText={formatStringWithPlaceholders(amountInputLabels.youWill, amountInputLabels.receive)}
          amount={B.amount}
          mint={B.mintAddress}
          onAmountChange={(event, rawValue) => {
            setPoolOperation(poolStakingOperation);
            const amount = rawValue;
            if (B.amount !== amount) {
              setLastTypedAccount(B.mintAddress);
            }

            B.setAmount(amount);
          }}
          showMaxButton={false}
        />
      </StakingContainer>
      <TradeButton disabled={stakeActionDisabled} onClick={() => onStakeAction(stakeAction)}>
        {buttonMessage}
      </TradeButton>
    </>
  );
};

const StakingContainer = styled.div`
  margin-bottom: 20px;
  border-radius: 0 8px 8px 8px;
  background-color: #141414;
`;

const IconWrapper = styled.div`
  text-align: center;
  margin: 12px 0 12px 0;
  padding: 0;
  height: 28px;
`;
